export default "__VITE_ASSET__CihdyOUm__"